import { ContentItemResourceType } from '@/modules/content-item/models/content-item-resource.model'

export function adminContentItemShowTabularColumns() {
  return [
    {
      name: 'id',
      title: 'کد'
    },
    {
      name: 'status',
      title: 'وضعیت'
    },
    {
      name: 'main_keyword',
      title: 'کلمه کلیدی'
    },
    {
      name: 'date',
      title: 'تاریخ تقریبی تحویل'
    },
    {
      name: 'campaign_id',
      title: 'شماره کمپین'
    },
    {
      name: 'actions',
      title: ''
    }
  ]
}

export function panelContentItemShowTabularColumns(contentItem: ContentItemResourceType) {
  const columns = [
    // {
    //   name: 'title',
    //   title: '',
    //   value: ''
    // },
    {
      name: 'status',
      title: 'وضعیت '
    },
    {
      name: 'deliver_at',
      title: 'تاریخ تقریبی تحویل'
    },
    {
      name: 'completed_at',
      title: 'تاریخ تکمیل'
    },
    {
      name: 'id',
      title: 'شماره مقاله',
      value: contentItem.data.id
    }
  ]

  if (contentItem.data.campaign) {
    columns.push({
      name: 'campaign',
      title: 'کمپین'
    })
  }

  return columns
}